import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const AssessmentFilters = ({ onFiltersChange, onClearFilters }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    status: '',
    department: '',
    priority: '',
    assignee: '',
    dateFrom: '',
    dateTo: '',
    gapThreshold: ''
  });

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'open', label: 'Open' },
    { value: 'in-review', label: 'In Review' },
    { value: 'remediation', label: 'Remediation' },
    { value: 'closed', label: 'Closed' }
  ];

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'engineering', label: 'Engineering' },
    { value: 'sales', label: 'Sales' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'hr', label: 'Human Resources' },
    { value: 'finance', label: 'Finance' },
    { value: 'operations', label: 'Operations' }
  ];

  const priorityOptions = [
    { value: '', label: 'All Priorities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const assigneeOptions = [
    { value: '', label: 'All Assignees' },
    { value: 'sarah-chen', label: 'Sarah Chen' },
    { value: 'michael-rodriguez', label: 'Michael Rodriguez' },
    { value: 'emma-thompson', label: 'Emma Thompson' },
    { value: 'david-kim', label: 'David Kim' },
    { value: 'lisa-anderson', label: 'Lisa Anderson' }
  ];

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleClearAll = () => {
    const clearedFilters = {
      status: '',
      department: '',
      priority: '',
      assignee: '',
      dateFrom: '',
      dateTo: '',
      gapThreshold: ''
    };
    setFilters(clearedFilters);
    onClearFilters();
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filter Assessments</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClearAll}
            iconName="X"
            iconPosition="left"
            className="text-muted-foreground hover:text-foreground"
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label={t('jointAssessments.filters.status')}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
          placeholder={t('jointAssessments.filters.selectStatus')}
        />

        <Select
          label={t('jointAssessments.filters.department')}
          options={departmentOptions}
          value={filters?.department}
          onChange={(value) => handleFilterChange('department', value)}
          placeholder={t('jointAssessments.filters.selectDepartment')}
        />

        <Select
          label={t('jointAssessments.filters.priority')}
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => handleFilterChange('priority', value)}
          placeholder={t('jointAssessments.filters.selectPriority')}
        />

        <Select
          label={t('jointAssessments.filters.assignee')}
          options={assigneeOptions}
          value={filters?.assignee}
          onChange={(value) => handleFilterChange('assignee', value)}
          placeholder={t('jointAssessments.filters.selectAssignee')}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input
          label={t('jointAssessments.filters.dateFrom')}
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          label={t('jointAssessments.filters.dateTo')}
          type="date"
          value={filters?.dateTo}
          onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
        />

        <Input
          label={t('jointAssessments.filters.minGap')}
          type="number"
          placeholder="e.g., 5"
          value={filters?.gapThreshold}
          onChange={(e) => handleFilterChange('gapThreshold', e?.target?.value)}
          min="0"
          max="100"
        />
      </div>
    </div>
  );
};

export default AssessmentFilters;